import { render } from '@testing-library/react';
import { BrowserRouter } from 'react-router-dom';

export const renderForTest = (component: any) => {
  const wrappedComponent = <BrowserRouter>{component} </BrowserRouter>;
  return render(wrappedComponent);
};
